import React from 'react';
import { Input as OldInput } from 'antd';

const Input = ({ className = '', ...props }) => {
  return <OldInput type="text" {...props} className={`${className} input-public `} />;
};

export default Input;
